export const log_out = () => (
  <path
    d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4m7 14l5-5m0 0l-5-5m5 5H9"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
